var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98723 11.5098C6.08652 11.5098 3.60938 11.9483 3.60938 13.7048C3.60938 15.4612 6.0708 15.9155 8.98723 15.9155C11.8879 15.9155 14.3644 15.4762 14.3644 13.7205C14.3644 11.9648 11.9037 11.5098 8.98723 11.5098Z",
    stroke: "#30BEAD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98622 9.0049C10.8898 9.0049 12.4327 7.46133 12.4327 5.55776C12.4327 3.65419 10.8898 2.11133 8.98622 2.11133C7.08265 2.11133 5.53908 3.65419 5.53908 5.55776C5.53265 7.4549 7.06551 8.99847 8.96194 9.0049H8.98622Z",
    stroke: "#30BEAD",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.ef42b156fb947c371641ff2d22646a16.svg";
export { ForwardRef as ReactComponent };